import { reactive } from 'vue';
import { supabase } from '../supabase';

const ustore = reactive({
  uData: {},
});

async function fetchUserData() {
    const { data: { user },error } = await supabase.auth.getUser();

  if (error) {
    console.error(error);
    return;
  }

  ustore.uData = user;
}


supabase.auth.onAuthStateChange((event, session) => {
  if (event === 'SIGNED_IN') {
    // fetchUserData();
    ustore.uData = session.user
  } else if (event === 'SIGNED_OUT') {
    ustore.uData = {};
  }
});


fetchUserData();


export default ustore;